import { render, staticRenderFns } from "./TheOrganizationEdit.vue?vue&type=template&id=58c082e1"
import script from "./TheOrganizationEdit.vue?vue&type=script&lang=js"
export * from "./TheOrganizationEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports